<div mat-dialog-title>
    <div class="spacer"></div>
    <button mat-mini-fab color="warn" class="close-button" mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content class="report">
    <iframe [src] = "pdf" style="width: 100%; height: 78vh;"></iframe>
  </div>
  <!--div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cerrar</button>
  </div-->